import $ from 'jquery';

function scrollTo($el) {
  $('html, body').animate({
    scrollTop: ($el.offset().top - 90)
  }, 1300);
}

export default scrollTo;